<template>
  <div class="leco-content"></div>
</template>

<script>
export default {
  name: "sso-redirect",
  data() {
    return {
      email: null,
      password: null,
      errorMessages: [],
      logger: this.$store.state.logger,
      //格納されたセッションストレージからリダイレクト先の情報を取得する
      redirectUrl: sessionStorage.getItem("redirect_path")
    };
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.$router.replace(this.redirectUrl);
    this.logger.info("redirect_url.");
    this.logger.info(sessionStorage.getItem("redirect_path"));
  }
};
</script>

<style scoped>
.auth-page {
  flex: 1;
}
</style>
